/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import * as S from "./Select.styled";

const Select = ({
  selected,
  title,
  placeholder,
  options,
  errorMessage,
  disabled,
  isRequired,
  onChange,
  ...props
}) => {
  const hasError = "";

  return (
    <S.SelectContainer disabled={disabled}>
      <label>
        {title} {isRequired && <S.RequiredIcon>*</S.RequiredIcon>}
      </label>
      <S.SelectInput
        {...props}
        value={selected?.value}
        placeholder={placeholder}
        onChange={(e) => {
          const selectedOption = options.find(
            (option) => option.value === e.target.value
          );
          onChange(selectedOption)
        }}
        error={hasError || errorMessage}
        errorMessage={hasError || selected?.value === undefined ? errorMessage : ""}
      >
        {options.map(({ value, label, id }) => (
          <S.Item
            key={id}
            value={value}
            text={label}
            selected={selected?.label === label}
          />
        ))}
      </S.SelectInput>
    </S.SelectContainer>
  );
};

export default Select;
